import React from 'react';
import StageList from './StageList';
import { PROGRESS_KEYS, travelCatalog } from './travelColumns';

const noRows = [];
const definitions = {
  ATTENDED: {
    title: 'ATENDIDAS - VIAGENS',
    loadingLabel: 'viagens atendidas',
  },
  IN_TRANSIT: {
    title: 'EM VIAGEM',
    loadingLabel: 'viagens em andamento',
  },
  AT_DESTINATION: {
    title: 'NO DESTINO',
    loadingLabel: 'viagens no destino',
  },
};

// Ordem das colunas por aba, conforme o modelo novo: Atendidas (5668), Em viagem (5669) e
// No destino (5670).
const ORDER = {
  ATTENDED: [
    'position',
    'travel',
    'reference',
    'status',
    'client',
    'product',
    'amount',
    'carrier',
    'driver',
    'driverPhone',
    'vehicle',
    'link',
    'payable',
    'origin',
    'destination',
    'km',
    'pickup',
    'delivery',
    'loadingStarted',
    'loadingFinished',
    'tracking',
    'lastPosition',
    'observations',
    'updated',
    'pcp',
    'negotiator',
  ],
  IN_TRANSIT: [
    'position',
    'deadline',
    'travel',
    'reference',
    'client',
    'product',
    'amount',
    'carrier',
    'driver',
    'driverPhone',
    'vehicle',
    'link',
    'payable',
    'origin',
    'destination',
    'km',
    'kmCovered',
    'kmRemaining',
    'transitTime',
    'arrival',
    'loadingStarted',
    'loadingFinished',
    'delivery',
    'tracking',
    'lastPosition',
    'observations',
    'updated',
    'responsible',
    'costCenter',
  ],
  AT_DESTINATION: [
    'position',
    'deadline',
    'travel',
    'reference',
    'client',
    'product',
    'amount',
    'carrier',
    'driver',
    'driverPhone',
    'vehicle',
    'link',
    'payable',
    'origin',
    'destination',
    'km',
    'kmCovered',
    'transitTime',
    'delivery',
    'unloadingStarted',
    'unloadingFinished',
    'tracking',
    'lastPosition',
    'observations',
    'updated',
    'responsible',
    'costCenter',
  ],
};

export default function TravelStageList({ context, rowIntegrations = {}, ...props }) {
  const code = context.group;
  const definition = definitions[code];
  if (!definition) return <p role="alert">Etapa de viagens não reconhecida.</p>;
  const {
    occurrences: Occurrences,
    transitTimeProvider: TransitTimeProvider,
    travelProgressValue: ProgressValue,
  } = rowIntegrations;
  const integrationProps = (item) => ({ item, context, onChanged: props.onRefresh });
  const catalog = travelCatalog({ Occurrences, ProgressValue, integrationProps });
  const columns = ORDER[code].map((key) => catalog[key]);
  const list = (
    <StageList
      {...props}
      context={context}
      key={code}
      columns={columns}
      definition={{
        ...definition,
        code,
        className: 'tc-k-travel-list',
        tableLabel: `Lista ${definition.loadingLabel}`,
        emptyMessage: 'Nenhuma viagem nesta etapa.',
      }}
    />
  );
  // Colunas do travel-progress, lido em lote para as viagens da página.
  return TransitTimeProvider && ORDER[code].some((key) => PROGRESS_KEYS.includes(key)) ? (
    <TransitTimeProvider context={context} rows={props.queryState.groups?.[code]?.data || noRows}>
      {list}
    </TransitTimeProvider>
  ) : (
    list
  );
}
